import {CONTENT_TAB_SET_ROUTE} from '@/store/content_tabs/mutations_types'

export default {
    [CONTENT_TAB_SET_ROUTE]: (state, data) => {
        state.previousRoute = data
    }
}